import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ExpepharmaAlertComponent } from '@expepharma/components/alert/alert.component';

@NgModule({
    declarations: [ExpepharmaAlertComponent],
    imports: [CommonModule, MatButtonModule, MatIconModule],
    exports: [ExpepharmaAlertComponent],
})
export class ExpepharmaAlertModule {}
